export const getMeta = (
  isCoverLetterRoot: boolean
): { title: string; description: string } => {
  if (isCoverLetterRoot) {
    return {
      title: 'Das perfekte Anschreiben - im Anschreiben-Ratgeber',
      description:
        'In unserem Anschreiben Ratgeber findest Du wertvolle Tipps für deinen Anschreiben und deine Bewerbung. Darauf solltest Du achten!',
    };
  }
  return {
    title: 'Der Weg zum perfekten Anschreiben - Der Lebenslauf Ratgeber',
    description:
      'In unserem Lebenslauf Ratgeber findest Du wertvolle Tipps für dein Anschreiben und deine Bewerbung. Hier erfährst Du worauf es zu achten gilt und welche Fehler Du besser vermeiden solltest!',
  };
};
